export const validateFirst = (firstname) => {
  if (!firstname) {
    return "First name is required";
  } else if (typeof firstname !== "string" || firstname?.length < 2) {
    return `First name must be at least 2 characters`;
  } else return "";
};

export const validateLast = (lastname) => {
  if (!lastname) {
    return "Last name is required";
  } else if (typeof lastname !== "string" || lastname?.length < 3) {
    return `Last name must be at least 3 characters`;
  } else return "";
};

export const validateEmail = (email) => {
  if (!email) {
    return "Email is Required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return "Invalid Email Address";
  } else return "";
};

export const validatePassword = (password) => {
  if (!password) {
    return "Password is required";
  } else if (typeof password !== "string" || password?.length < 8) {
    return `Passwords must be at least 8 characters long`;
  } else if (password?.length > 0) {
      let PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d).{8,100}$/;
    if (!PASSWORD_REGEX.test(password)) {
      return "Minimum 8 characters, at least one letter and one number required";
    } else return "";
  } else return "";
};

/** Rules for registration / password-create flows (stricter than login validation). */
const PASSWORD_LINE_TERMINATOR_REGEX = /[\n\r\u2028\u2029]/;

export const PASSWORD_RULES = [
  {
    id: "minLength",
    label: "At least 8 characters",
    test: (password) => typeof password === "string" && password.length >= 8,
  },
  {
    id: "uppercase",
    label: "At least one uppercase letter",
    test: (password) => /[A-Z]/.test(password || ""),
  },
  {
    id: "lowercase",
    label: "At least one lowercase letter",
    test: (password) => /[a-z]/.test(password || ""),
  },
  {
    id: "number",
    label: "At least one number",
    test: (password) => /\d/.test(password || ""),
  },
  {
    id: "noLineBreaks",
    label: "No line breaks",
    test: (password) => !PASSWORD_LINE_TERMINATOR_REGEX.test(password || ""),
  },
];

export const getPasswordRuleChecks = (password) =>
  PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(password),
  }));

export const isPasswordRulesSatisfied = (password) =>
  PASSWORD_RULES.every((rule) => rule.test(password));

export const validateRegistrationPassword = (password) => {
  if (!password) {
    return "Password is required";
  }
  if (typeof password !== "string" || password.length > 100) {
    return "Password must be 100 characters or fewer";
  }
  if (PASSWORD_LINE_TERMINATOR_REGEX.test(password)) {
    return "Password cannot contain line breaks";
  }
  if (!isPasswordRulesSatisfied(password)) {
    return "Password does not meet all requirements";
  }
  return "";
};

export const validateConfirmPassword = (password, cpassword) => {
  if (!cpassword) {
    return "Password confirmation is required";
  } else if (password !== cpassword) {
    return "Password does not match";
  } else return "";
};

export const validateCompany = (companyname) => {
  if (!companyname) {
    return "Company is required";
  } else return "";
};
